import AdminNewReviewsPage from './AdminNewReviewsPage'
export default AdminNewReviewsPage;